"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Add event(s) to element(s).
 * @param elements DOM-Elements
 * @param events Event names
 * @param fn Callback
 * @param options Optional options
 * @return Array passed arguments
 */
exports.on = eventListener.bind(null, 'addEventListener');
/**
 * Remove event(s) from element(s).
 * @param elements DOM-Elements
 * @param events Event names
 * @param fn Callback
 * @param options Optional options
 * @return Array passed arguments
 */
exports.off = eventListener.bind(null, 'removeEventListener');
function eventListener(method, elements, events, fn, options) {
    if (options === void 0) { options = {}; }
    // Normalize array
    if (elements instanceof HTMLCollection || elements instanceof NodeList) {
        elements = Array.from(elements);
    }
    else if (!Array.isArray(elements)) {
        elements = [elements];
    }
    if (!Array.isArray(events)) {
        events = [events];
    }
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var el = elements_1[_i];
        for (var _a = 0, events_1 = events; _a < events_1.length; _a++) {
            var ev = events_1[_a];
            el[method](ev, fn, __assign({ capture: false }, options));
        }
    }
    return Array.prototype.slice.call(arguments, 1);
}
/**
 * Creates an DOM-Element out of a string (Single element).
 * @param html HTML representing a single element
 * @returns {Element | null} The element.
 */
function createElementFromString(html) {
    var div = document.createElement('div');
    div.innerHTML = html.trim();
    return div.firstElementChild;
}
exports.createElementFromString = createElementFromString;
/**
 * Removes an attribute from a HTMLElement and returns the value.
 * @param el
 * @param name
 * @return {string}
 */
function removeAttribute(el, name) {
    var value = el.getAttribute(name);
    el.removeAttribute(name);
    return value;
}
exports.removeAttribute = removeAttribute;
/**
 * Creates a new html element, every element which has
 * a 'data-key' attribute will be saved in a object (which will be returned)
 * where the value of 'data-key' ist the object-key and the value the HTMLElement.
 *
 * It's possible to create a hierarchy if you add a 'data-con' attribute. Every
 * sibling will be added to the object which will get the name from the 'data-con' attribute.
 *
 * If you want to create an Array out of multiple elements, you can use the 'data-arr' attribute,
 * the value defines the key and all elements, which has the same parent and the same 'data-arr' attribute,
 * would be added to it.
 *
 * @param str - The HTML String.
 */
function createFromTemplate(str) {
    // Recursive function to resolve template
    function resolve(element, base) {
        if (base === void 0) { base = {}; }
        // Check key and container attribute
        var con = removeAttribute(element, 'data-con');
        var key = removeAttribute(element, 'data-key');
        // Check and save element
        if (key) {
            base[key] = element;
        }
        // Check all children
        var subtree = con ? (base[con] = {}) : base;
        for (var _i = 0, _a = Array.from(element.children); _i < _a.length; _i++) {
            var child = _a[_i];
            // Check if element should be saved as array
            var arr = removeAttribute(child, 'data-arr');
            if (arr) {
                // Check if there is already an array and add element
                (subtree[arr] || (subtree[arr] = [])).push(child);
            }
            else {
                resolve(child, subtree);
            }
        }
        return base;
    }
    return resolve(createElementFromString(str));
}
exports.createFromTemplate = createFromTemplate;
/**
 * Polyfill for safari & firefox for the eventPath event property.
 * @param evt The event object.
 * @return [String] event path.
 */
function eventPath(evt) {
    var path = evt.path || (evt.composedPath && evt.composedPath());
    if (path)
        return path;
    var el = evt.target.parentElement;
    path = [evt.target, el];
    while (el = el.parentElement)
        path.push(el);
    path.push(document, window);
    return path;
}
exports.eventPath = eventPath;
/**
 * Creates the ability to change numbers in an input field with the scroll-wheel.
 * @param el
 * @param negative
 */
function adjustableInputNumbers(el, negative) {
    if (negative === void 0) { negative = true; }
    // Check if a char represents a number
    var isNumChar = function (c) { return (c >= '0' && c <= '9') || c === '-' || c === '.'; };
    function handleScroll(e) {
        var val = el.value;
        var off = el.selectionStart;
        var numStart = off;
        var num = ''; // Will be the number as string
        // Look back
        for (var i = off - 1; i > 0 && isNumChar(val[i]); i--) {
            num = val[i] + num;
            numStart--; // Find start of number
        }
        // Look forward
        for (var i = off, n = val.length; i < n && isNumChar(val[i]); i++) {
            num += val[i];
        }
        // Check if number is valid
        if (num.length > 0 && !isNaN(num) && isFinite(num)) {
            var mul = e.deltaY < 0 ? 1 : -1;
            var inc = ([1, 10, 100])[Number(e.shiftKey || e.ctrlKey * 2)] * mul;
            var newNum = Number(num) + inc;
            if (!negative && newNum < 0) {
                newNum = 0;
            }
            var newStr = val.substr(0, numStart) + newNum + val.substring(numStart + num.length, val.length);
            var curPos = numStart + String(newNum).length;
            // Update value and set cursor
            el.value = newStr;
            el.focus();
            el.setSelectionRange(curPos, curPos);
        }
        // Prevent default
        e.preventDefault();
        // Trigger input event
        el.dispatchEvent(new Event('input'));
    }
    // Bind events
    exports.on(el, 'focus', function () { return exports.on(window, 'wheel', handleScroll, { passive: false }); });
    exports.on(el, 'blur', function () { return exports.off(window, 'wheel', handleScroll); });
}
exports.adjustableInputNumbers = adjustableInputNumbers;
